import { useCallback } from "react";

import { useAccountType } from "@js/apps/common/hooks";
import { WELCOME_MODAL_PARAM } from "@js/apps/employer/hooks/use-employer-welcome-modal";
import { globalConfig } from "@js/constants";
import { useNavigate } from "@js/hooks";
import type { UnverifiedUser } from "@js/types/auth";
import { iframePostMessage, isInIframe } from "@js/utils";

const getRedirectPathForUnfinishedUser = (isEmployer: boolean) => {
  if (isEmployer) {
    return `/?${WELCOME_MODAL_PARAM}=true`;
  }
  return "/";
};

export const useRedirectAfterSignUp = (unfinishedUser?: UnverifiedUser) => {
  const { isEmployer } = useAccountType();
  const navigate = useNavigate();

  const redirect = useCallback(() => {
    if (!unfinishedUser) return;

    const redirectPath = getRedirectPathForUnfinishedUser(isEmployer);

    if (isInIframe()) {
      globalConfig.surpressDisplayGenericRequestError = true;
      iframePostMessage({ redirect: window.location.origin });
    } else {
      navigate(redirectPath);
    }
  }, [navigate, unfinishedUser, isEmployer]);

  return redirect;
};
